import React from 'react'
import { observer } from 'mobx-react'
import { OrderFulfillmentStatus } from '../../../interfaces'
import { FavouriteOrderTag, ReorderButton } from '../../order'
import { collectionsStore } from '../collections.store'

interface IProps {
  customerIsAllowed: boolean
}

@observer
export class FavouriteOrdersList extends React.Component<IProps> {
  render(): React.ReactNode {
    const favOrdersList = collectionsStore.favouriteOrders

    return (
      favOrdersList.length > 0 && (
        <>
          <h2>Favourite Order</h2>
          <table className='responsive-table m-top order-history-table small--hide' id='favourite-orders-table'>
            <thead>
              <tr>
                <th>ORDER NO.</th>
                <th></th>
                <th>DATE ORDERED</th>
                <th>DATE RECEIVED</th>
                <th>TOTAL UNITS</th>
                <th>TOTAL PRICE</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {favOrdersList.map((order) => (
                <React.Fragment key={order.id}>
                  <tr className='responsive-table-row'>
                    <td data-label='Order No.' style={{ display: 'flex' }}>
                      <a href='#' onClick={() => (window as any).getOrderProducts(order.customer_url, order.id)}>
                        {order.name}
                      </a>
                    </td>
                    <td data-label='Favourite Order'>
                      <div id={`favourite-order-tag-${order.id}`} key={order.id}>
                        <FavouriteOrderTag currentOrder={order} orders={collectionsStore.customerOrdersWithFavTag} />
                      </div>
                    </td>
                    <td data-label='Date Ordered'>{order.created_at}</td>
                    <td data-label='Date Received'>
                      {order.fulfillment_status === OrderFulfillmentStatus.unfulfilled ? '-' : order.attributes && order.attributes.delivery_day}
                    </td>
                    <td data-label='Total Units'>{order.line_items.length}</td>
                    <td data-label='Total Price'>{order.total_price}</td>
                    <td>
                      {this.props.customerIsAllowed && (
                        <div className='react-reorder' id={`reorder--{order.id}`}>
                          <ReorderButton items={order.line_items} style='link' />
                        </div>
                      )}
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>

          {/* Mobile View */}
          {favOrdersList.map((order) => (
            <React.Fragment key={order.id}>
              <div className='order-history-mobile medium-up--hide'>
                <div className='grid'>
                  <div className='grid__item small--one-quarter'>
                    <div>
                      <p>
                        <a href='#' onClick={() => (window as any).getOrderProducts(order.customer_url, order.id)}>
                          {order.name}
                        </a>
                      </p>
                      <div id={`favourite-order-tag-${order.id}`} key={order.id}>
                        <FavouriteOrderTag currentOrder={order} orders={collectionsStore.customerOrdersWithFavTag} />
                      </div>
                    </div>
                  </div>
                  <div className='grid grid--table'>
                    <div className='grid__item grid__cell'>
                      <h5>Ordered</h5>
                      <p className='small'>
                        {Intl.DateTimeFormat('au', {
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric'
                        })
                          .format(new Date(order.created_at))
                          .split('/')
                          .join('.')}
                      </p>
                    </div>
                    <div className='grid__item grid__cell'>
                      <h5>Received</h5>
                      <p className='small'>
                        {order.fulfillment_status === OrderFulfillmentStatus.unfulfilled || !(order.attributes && order.attributes.delivery_day)
                          ? '-'
                          : Intl.DateTimeFormat('au', {
                              day: '2-digit',
                              month: '2-digit',
                              year: 'numeric'
                            })
                              .format(new Date(order.attributes.delivery_day))
                              .split('/')
                              .join('.')}
                      </p>
                    </div>
                    <div className='grid__item grid__cell'>
                      <h5>Units</h5>
                      <p className='small'>{order.line_items.length}</p>
                    </div>
                    <div className='grid__item grid__cell'>
                      <h5>Price</h5>
                      <p className='small'>{order.total_price}</p>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          ))}
        </>
      )
    )
  }
}
